module.exports = __webpack_public_path__ + "img/img4512.a2c85883.jpg";